import React from "react";
var __jsx = React.createElement;
var AllUspsItem = function AllUspsItem(_ref) {
  var src = _ref.src,
    title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-7 items-start"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: title,
    width: "30px",
    height: "30px",
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary text-base font-bold text-start"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-light-slate text-base font-normal leading-7 text-start"
  }, description))));
};
export default AllUspsItem;